import EstimateItem from "./estimate-item";
import { CONSUMPTION_TAX_RATE } from "@/preferences";
import { ProjectTaskDefault } from "@/api/project-api";
import EstimateStatus from "@/usecases/orders/estimate-status";

export default class Estimate {
  id: number = 0;
  estimateNumber: string = "";
  title: string = "";
  attention: string = "";
  mention: string = "";
  projectId: number = 0;
  projectName: string = "";
  projectClientName: string = "";
  staffName: string = "";
  status: string = EstimateStatus.CreatedNew;
  items: EstimateItem[] = [];
  total: number = 0;
  subtotal: number = 0;
  tax: number = 0;
  taxRate: number = CONSUMPTION_TAX_RATE;
  loss: number = 0;
  taxLoss: number = 0;
  lossRate: number = 0;
  printsExcludeTax: boolean = false;
  dateOfIssue: string = "";
  dateOfContract: string = "";
  deadline: string = "";
  profitRate: number = 0;
  discount: number = 0;
  children: Estimate[] = [];
  taskDefaults: ProjectTaskDefault[] = [];
  categoryDiscountIds: string[] = [];
  orderNew: number = 1;
  hasProjectId?: boolean = false;
  createOrderNew?: boolean = false;
  isEditable: boolean = true;
  isFromActualResult: boolean = false;
  /** 支払い方法（選択値） */
  paymentMethod: string = "";
  /** 支払い方法の選択肢（マスタ・所属支店） */
  estimatePaymentMethods: string[] = [];
}
